var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-card-actions',[_c('v-spacer'),_c('v-btn',{attrs:{"button-full":"","size":"large"},on:{"click":function($event){return _vm.anotherTask()}}},[_vm._v(" Ok ")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }